module.exports = __webpack_public_path__ + "static/media/pressure-plate-analysis.0470d254.jpg";